import React from 'react'
import classNames from 'classnames'
import { useHlsPlayerUI } from './HlsPlayerUIContext'

interface HlsTitleBarProps {
  visible: boolean
}

/**
 * Title bar overlay at the top of the player.
 * Shows the video title with a gradient background that fades in/out
 * together with the control bar.
 */
export const HlsTitleBar: React.FC<HlsTitleBarProps> = ({ visible }) => {
  const { title } = useHlsPlayerUI()

  if (!title) return null

  return (
    <div
      className={classNames(
        'absolute inset-x-0 top-0 bg-gradient-to-b from-black/70 via-black/40 to-transparent px-4 pb-10 pt-3 transition-opacity duration-[400ms]',
        visible ? 'opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      <p className="photon-title-sm truncate font-medium text-white">{title}</p>
    </div>
  )
}
